<template>
<v-container>
    <v-layout row wrap>
        <v-flex xs9>
            <v-textarea name="selectList" v-model="selectList" label="Paste select List" v-validate="'required'" :error-messages="errors.collect('selectList')"></v-textarea>
        </v-flex>
      <v-flex xs3>
          <v-card>
              <v-title>Help with this form</v-title>
            <v-card-text>
              
        <label>For assistance with this form please watch this video clip: <a href="https://www.vonex.com.au/images/media/missing-dealer.mp4" target="_blank">Missing Dealer Video</a> </label>
            </v-card-text>
          </v-card>
      </v-flex>
        <v-flex xs12>
            <v-btn @click="getMissing" color="success">Get Missing Dealers</v-btn>
        </v-flex>

        <v-layout row wrap>
            <v-title>Dealers Missing in Sign On Glass</v-title>
            <v-flex xs12>
                <v-data-table :headers="headers" :items="sogDealers" :pagination.sync="pagination" hide-actions class="elevation-1">
                    <template slot="items" slot-scope="props">
                        <td v-for="(prop,propIndex) in headers.filter(x => x.text !=='Actions')" :key="propIndex" :class="'ma-0'">

                            <div :class="'text-xs-' + prop.align">
                                {{props.item[prop.value]}}
                            </div>

                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-title>Dealers Missing in UB</v-title>
            <v-flex xs12>
                <v-data-table :headers="headers" :items="ubDealers" :pagination.sync="pagination" hide-actions class="elevation-1">
                    <template slot="items" slot-scope="props">
                        <td v-for="(prop,propIndex) in headers.filter(x => x.text !=='Actions')" :key="propIndex" :class="'ma-0'">

                            <div :class="'text-xs-' + prop.align">
                                {{props.item[prop.value]}}
                            </div>

                        </td>

                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-layout>
</v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from "vuex";
const { mapActions: mapDealerActions } = createNamespacedHelpers(
  "orders/dealer"
);

export default {
  name: "missing-dealer",
  components: {},

  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 20,
        totalItems: 0
      },
      sogDealers: [],
      ubDealers: [],
      headers: [
        {
          text: "Dealer Id",
          align: "left",
          sortable: false,
          value: "dealerID"
        },
        {
          text: "UB Dealer Id",
          value: "ubDealerID"
        },
        {
          text: "Dealer Full Name",
          value: "dealerFullName"
        },
        {
          text: "Dealer Email",
          value: "dealerEmail"
        }
      ],
      selectList: null
    };
  },
  methods: {
    ...mapDealerActions(["listMissingDealers"]),
    getMissing() {
      let vm = this;
      this.listMissingDealers(vm.selectList)
        .then(data => {
          vm.ubDealers = data.ubDealers;
          vm.sogDealers = data.sogDealers;
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
</style>
